<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons class="ion-text-left" slot="start">
      <ion-button  (click)="onDismiss()" >
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Select a Booking</ion-title>
  </ion-toolbar>

  <ion-toolbar>
    <salonmonster-date-picker
      [startDate]="startDate"
      [endDate]="endDate"
      [hideGroupBy]="true"
      [disabled]="isLoading"
      (rangeChanged)="rangeChanged($event)"
    ></salonmonster-date-picker>
  </ion-toolbar>
</ion-header>

<ion-content>
  <smr-stylist-picker
  [stylistID]="stylistID" 
  [readOnly]="readOnlyStylistPicker"
  (onInit)="onStylistPickerInit($event)"
  (stylistSelect)="onStylistSelect($event)"
  cssClass="smr-stylist-picker-for-bookings"
  >  
</smr-stylist-picker>
<div>
  <ion-item *ngIf="bookings.count() == 0">
    No Bookings
  </ion-item>

  <smr-booking-item 
    *ngFor="let booking of bookings" 
    [booking]="booking"
    (click)="bookingSelect(booking)"
    >
  </smr-booking-item>

  <salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>

  <salonmonster-tap-retry *ngIf="errorOccurredWhileLoadingBookings || errorOccurredWhileLoadingStylistPicker" (click)="onTapToReload()"></salonmonster-tap-retry>
</div>
</ion-content>
